import { render } from "./OnuBoard.vue?vue&type=template&id=4c4d7235"
import script from "./OnuBoard.vue?vue&type=script&lang=js"
export * from "./OnuBoard.vue?vue&type=script&lang=js"

import "./OnuBoard.vue?vue&type=style&index=0&id=4c4d7235&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__